import {
  MessageSquare,
  FileText,
  Users,
  Upload,
  Clock,
  Database,
  Building,
  Search,
  Phone,
  FolderKanban,
  Share2,
  Megaphone,
  Play,
  Handshake,
  LogOut,
  Settings,
} from "lucide-react";

/**
 * Production CRM deep-link used by all TARS environments.
 * ASSUMPTION: There is no per-env CRM host today; staging/dev intentionally open prod CRM.
 * If multi-env CRM hosts appear later, switch this to `import.meta.env.VITE_CRM_URL` with a default.
 */
export const CRM_EXTERNAL_URL = "https://crm.horaizen.io/";

/** Stable id for CRM nav filtering (path allowlists stay path-only). */
export const CRM_NAV_ITEM_ID = "crm";

/** Stable id for Referrals PoC nav filtering (path allowlists stay path-only). */
export const REFERRALS_NAV_ITEM_ID = "referrals";

/** In-app PoC wrapper route for Referrals. */
export const REFERRALS_POC_PATH = "/beta/referrals";

/**
 * @param {unknown} url
 * @returns {boolean}
 */
export function isAbsoluteHttpUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url);
}

/**
 * Single signal for external sidebar navigation (open path + active-state skip).
 * Fail-safe: absolute http(s) URLs are always treated as external even without `external: true`.
 *
 * @param {{ external?: boolean, url?: string } | null | undefined} item
 * @returns {boolean}
 */
export function isExternalNavItem(item) {
  return Boolean(item?.external) || isAbsoluteHttpUrl(item?.url);
}

/**
 * Fail-closed allowlist for external nav URLs (HTTPS + CRM origin only).
 *
 * @param {unknown} url
 * @returns {boolean}
 */
export function isAllowedExternalNavUrl(url) {
  if (typeof url !== "string") return false;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") return false;
    return parsed.origin === new URL(CRM_EXTERNAL_URL).origin;
  } catch {
    return false;
  }
}

export const navigationItems = [
  { title: "Intents", url: "/intents", icon: MessageSquare, isActive: false },
  { title: "Prompts Builder", url: "/prompts", icon: FileText, isActive: false },
  { title: "Users", url: "/users", icon: Users, isActive: false },
  { title: "Customers", url: "/customers", icon: Users, isActive: false },
  { title: "Import", url: "/import", icon: Upload, isActive: false },
  { title: "Scheduled Messages", url: "/scheduled-messages", icon: Clock, isActive: false },
  { title: "Schema Management", url: "/schema-management", icon: Database, isActive: false },
  { title: "Opportunities", url: "/opportunities", icon: Handshake, isActive: false },
  { title: "Properties", url: "/properties", icon: Building, isActive: false },
  { title: "Parcel Search", url: "/parcel-search", icon: Search, isActive: false },
  { title: "Contacts", url: "/contacts", icon: Phone, isActive: false },
  { title: "Campaigns", url: "/campaigns", icon: Megaphone, isActive: true },
  { id: CRM_NAV_ITEM_ID, title: "CRM", url: CRM_EXTERNAL_URL, icon: FolderKanban, isActive: false, external: true },
  {
    id: REFERRALS_NAV_ITEM_ID,
    title: "Referrals",
    url: REFERRALS_POC_PATH,
    icon: Share2,
    isActive: false,
  },
  { title: "Campaign builder", url: "/campaign-builder", icon: Play, isActive: false },
];

const SETTINGS_FOOTER_ITEM = { title: "Settings", url: "/settings", icon: Settings, isActive: false };
const SIGN_OUT_FOOTER_ITEM = { title: "Sign Out", url: "/sign-out", icon: LogOut, isActive: false };

export function getFooterItems() {
  return [SETTINGS_FOOTER_ITEM, SIGN_OUT_FOOTER_ITEM];
}
